import axios from 'axios'

import {msalInstance} from '../configs/msalInstance'

const scope = process.env.REACT_APP_SCOPE as string

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

const waitForAccounts = async (retries = 10, interval = 200): Promise<any> => {
  while (retries > 0) {
    const accounts = msalInstance.getAllAccounts()

    if (accounts.length > 0) return accounts[0]

    await new Promise((res) => setTimeout(res, interval))
    retries--
  }

  throw new Error('No account available after waiting')
}

instance.interceptors.request.use(
  async (config) => {
    try {
      const account = await waitForAccounts()

      const response = await msalInstance.acquireTokenSilent({
        scopes: [scope],
        account,
      })
      config.headers?.set('Authorization', `Bearer ${response.accessToken}`)

      return config
    } catch (error) {
      console.error('Token error:', error)
      throw error
    }
  },
  (error) => Promise.reject(error)
)

export default instance
